module.exports = __webpack_public_path__ + "static/media/Purpose_20.1f424c6b.png";